var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63379 5.59999C2.63379 3.96472 3.97044 2.64285 5.59952 2.64285H8.01666C9.13421 2.64285 10.1613 3.27713 10.6647 4.27284L10.6652 4.27393L11.3575 5.64991C11.3867 5.705 11.4341 5.72857 11.4795 5.72857H16.3909C18.0301 5.72857 19.3567 7.05198 19.3567 8.68571V16.4C19.3567 18.0353 18.02 19.3571 16.3909 19.3571H5.59952C3.96032 19.3571 2.63379 18.0337 2.63379 16.4V5.59999ZM8.01666 3.92857H5.59952C4.67432 3.92857 3.9195 4.68099 3.9195 5.59999V16.4C3.9195 17.3206 4.66729 18.0714 5.59952 18.0714H16.3909C17.3161 18.0714 18.0709 17.319 18.0709 16.4V8.68571C18.0709 7.76514 17.3231 7.01428 16.3909 7.01428H11.4795C10.9425 7.01428 10.4591 6.71265 10.2139 6.23771L10.2109 6.2318L9.51719 4.85286C9.51714 4.85269 9.5173 4.85304 9.51719 4.85286C9.23187 4.28888 8.64749 3.92857 8.01666 3.92857Z",
    fill: "#4A4458"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58496 4.05713C9.58496 3.7021 9.87281 3.41428 10.2278 3.41428H14.8564C16.0578 3.41428 17.0264 4.37424 17.0506 5.56986L17.0507 5.58285V6.37142C17.0507 6.72648 16.7629 7.01428 16.4078 7.01428C16.0528 7.01428 15.765 6.72648 15.765 6.37142V5.59017C15.752 5.09135 15.3503 4.69999 14.8564 4.69999H10.2278C9.87281 4.69999 9.58496 4.41218 9.58496 4.05713Z",
    fill: "#4A4458"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49121 14.8571C6.49121 14.5021 6.77901 14.2143 7.13407 14.2143H10.2283C10.5834 14.2143 10.8712 14.5021 10.8712 14.8571C10.8712 15.2122 10.5834 15.5 10.2283 15.5H7.13407C6.77901 15.5 6.49121 15.2122 6.49121 14.8571Z",
    fill: "#4A4458"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/DocumentsIcon.cbe1522563725e4e8ce01b5608856e86.svg";
export { ForwardRef as ReactComponent };